import { get } from 'lodash-es';
import { SET_BRAND, SET_BRAND_ALERT, SET_BRAND_STORE, SET_LOADING_BRAND, UPDATE_BRAND } from '../actions/brand.actions';
import { RESET_STORE } from '../actions/config.actions';

const initialState = {
  brand: null,
  brandId: +localStorage.getItem('brandId'),
  path: '/brand',
  updateBrand: null,
  alertSettings: null,
  loading: false,
};

export default function brandReducer(state = initialState, action) {
  switch (action.type) {
    case SET_BRAND:
      return {
        ...state,
        brand: action.payload,
        brandId: get(action.payload, 'id')
      };
    case SET_LOADING_BRAND:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_BRAND_ALERT:
      return {
        ...state,
        alertSettings: action.payload
      };
    case SET_BRAND_STORE:
      if (action.payload) {
        localStorage.setItem('brandId', get(action.payload, 'brandId'));
      } else {
        localStorage.removeItem('brandId');
      }
      return {
        ...state,
        ...action.payload
      };
    case UPDATE_BRAND:
      return {
        ...state,
        updateBrand: action.payload
      };
    case RESET_STORE:
      localStorage.removeItem('brandId');
      return { ...initialState, brandId: null };
    default:
      return state;
  }
}